import { render } from "./prescript.vue?vue&type=template&id=1a17c0db"
import script from "./prescript.vue?vue&type=script&lang=js"
export * from "./prescript.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__